export const TABBAR_INDICATOR_INSET_X = -4;
export const TABBAR_INDICATOR_INSET_Y = 6;
export const TABBAR_INDICATOR_EDGE_MARGIN = 2;
